<template>
  <Auth>
    <section class="section">
      <div class="container mt-5">
        <div class="page-error">
          <div class="page-inner">
            <h1>403</h1>
            <div class="page-description">
            	Oops, you can't access this page
            </div>
            <div class="page-search">
              <form>
                <div class="form-group floating-addon floating-addon-not-append">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-search"></i>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
              <div class="mt-3">
                <router-link to="/">Go back home</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="simple-footer mt-5">
          Copyright &copy; JunoMarkets 2020
        </div>
      </div>
    </section>
  </Auth>
</template>

<script>
import Auth from '../layouts/Auth'
import Button from '@/components/utils/Button.vue'
export default {
  components: {
    Auth,
    Button
  },
  data() {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    login() {
      // TODO : Implements Auth
      this.loading = true
      this.$store.dispatch('user/login', {
        username: this.username,
        password: this.password
      }).then(() => {
        this.$router.push('/exposure')
      }).catch(error => {

        // Failed Login, show error
        this.loading = false
        this.$bvToast.toast(`Login failed, error : ${error.response.data.message}`, {
          title: 'Warning',
          error: true,
          variant: 'danger',
          autoHideDelay: 5000,
        })

      })
    }
  }
}
</script>
